export default "/images/login-vector1.svg?0219f4e0e25c2e9312418104cd297059";